module.exports = __webpack_public_path__ + "img/Si-Co.b45ff7d7.svg";